import { DtoFilesDeleteRes } from "./abst/DtoFilesDeleteRes";

export class DtoFilesDeleteResImple extends DtoFilesDeleteRes {
  public message: string | null = null;
}
